export default __webpack_public_path__ + "static/bottomSwirlImage2Mobile-5516748ff7877e3d729b54bb00fca05b.svg";